import { Route } from '@angular/router';
import { appResolver } from './app.resolver';
import { authGuard, noAuthGuard } from '@coworkrz/auth/data-access';
import { RefreshmentDetailsComponent } from '@coworkrz/refreshments/refreshment-details';
import { PortalBaseLayoutComponent } from '@coworkrz/shared/portal-layout';

export const appRoutes: Route[] = [
  {
    path: '',
    resolve: [appResolver],
    canActivate: [authGuard],
    component: PortalBaseLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@coworkrz/home/portal-home').then(
            (a) => a.PortalHomeComponent
          ),
      },
      {
        path: 'refreshments/:id',
        component: RefreshmentDetailsComponent,
      },
      {
        path: 'refreshments',
        loadComponent: () =>
          import('@coworkrz/refreshments/feature-list').then(
            (a) => a.PortalRefreshmentsComponent
          ),
      },
      {
        path: 'spaces/:id',
        loadComponent: () =>
          import('@coworkrz/spaces/feature-details').then(
            (a) => a.SpaceDetailsComponent
          ),
      },
      {
        path: 'spaces',
        loadComponent: () =>
          import('@coworkrz/spaces/feature-list').then(
            (a) => a.FeatureListComponent
          ),
      },
      {
        path: 'account',
        loadComponent: () =>
          import('@coworkrz/accounts/feature-account').then(
            (a) => a.PortalAccountLayoutComponent
          ),
        children: [
          {
            path: 'profile',
            loadComponent: () =>
              import('@coworkrz/accounts/feature-account').then(
                (a) => a.PortalProfileComponent
              ),
          },
        ],
      },
    ],
  },
  {
    path: '',
    canActivate: [noAuthGuard],
    children: [
      {
        path: 'start',
        loadComponent: () =>
          import('@coworkrz/auth/start').then((a) => a.AuthStartComponent),
        children: [
          {
            path: '',
            redirectTo: 'signup',
            pathMatch: 'full',
          },
          {
            path: 'signup',
            loadComponent: () =>
              import('@coworkrz/auth/portal-signup').then(
                (a) => a.PortalSignupComponent
              ),
          },
          {
            path: 'signin',
            loadComponent: () =>
              import('@coworkrz/auth/portal-signin').then(
                (a) => a.PortalSignInComponent
              ),
          },
        ],
      },
    ],
  },
];
